// 钱包相关

import { useSelector } from '@/store'

export function useWalletList() {
  const userInfoCurrencyCode = useSelector((s) => s.auth?.userInfo?.currencyCode)
  const userDefaultCurrencyCode = useSelector((s) => s.common.setting?.USER_DEFAULT_CURRENCY_CODE?.dataValue)
  const defaultWallet = useSelector((state) => state.auth.walletList.find((wallet) => wallet.currencyCode === (userDefaultCurrencyCode || userInfoCurrencyCode)))
  const walletList = useSelector((s) => s.auth.walletList)
  return { defaultWallet, walletList }
}
